"use client";
import { Link as ScrollLink } from "react-scroll";
import menu_data from "./MenuData";
import React, { useEffect, useState } from "react";
import Link from "next/link";

const MobileMenus = ({ setShowCanvas }: any) => {
  return (
    <>
      <ul>
        {menu_data.map((item, index) => (
          <React.Fragment key={index}>
            <li className="">
              {/* <ScrollLink to={item.link} onClick={() => setShowCanvas(false)}>
                {item.title}
              </ScrollLink> */}
              <Link href={item.link}>{item.title}</Link>
            </li>
          </React.Fragment>
        ))}
      </ul>
    </>
  );
};

export default MobileMenus;
